module.exports = __webpack_public_path__ + "img/publish.1d93f0be.png";